<form [formGroup]="form" (ngSubmit)="onSubmit()" style="display:grid; gap:12px;">
  <h2 mat-dialog-title class="dialog-icon-title">
    <mat-icon>security</mat-icon>
    <span i18n="@@section.signInMethods.securityVerification">Security verification</span>
  </h2>

  <div mat-dialog-content>
    <p i18n="@@section.signInMethods.reauth.password.message">
      Before proceeding, please enter your current password.
    </p>

    <mat-form-field style="width: 100%;">
      <mat-label i18n="@@common.email">Email</mat-label>
      <input matInput [value]="data.email" readonly disabled />
    </mat-form-field>

    <mat-form-field style="width: 100%;">
      <mat-label i18n="@@common.password">Password</mat-label>
      <input matInput type="password" formControlName="password" />
    </mat-form-field>

    <div *ngIf="data.errorMessage" class="error-message">
      {{ data.errorMessage }}
    </div>
  </div>

  <div mat-dialog-actions class="dialog-buttons">
    <button mat-stroked-button type="button" (click)="onCancel()" i18n="@@common.cancel">
      Cancel
    </button>
    <button mat-flat-button color="primary" [disabled]="form.invalid" i18n="@@common.confirm">
      Confirm
    </button>
  </div>
</form>
